import React, { useMemo } from 'react';
import NotesEditor from '../../../../shared/Notes/NotesEditor';
import { ResourcesTabParamList, useGoBack, useNotesTabNavigation } from '../../../../../utils/appNavigationNames';
import { useEditNote } from '../../../../../hooks/api/useNotes';
import { RouteProp } from '@react-navigation/native';
import { NoteDestination, noteDetailsToDestination } from '../../../../shared/Notes/utils/types';
import { useConfirmBackNavigationOnDirtyForm } from '../../../../shared/FormExitValidation';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { View } from 'react-native';

export type NoteEditScreenOwnProps = {};

export type NoteEditScreenProps = NoteEditScreenOwnProps & { route: RouteProp<ResourcesTabParamList, 'edit-note'> };

const NoteEditScreen: React.FC<NoteEditScreenProps> = (props) => {
    const goBack = useGoBack();
    const navigator = useNotesTabNavigation();
    useConfirmBackNavigationOnDirtyForm(navigator);
    const { note, isLoadingNote, key, noteEditorProps } = useEditNote({
        noteId: props.route.params.noteId,
        onUpdateSuccess: () => {
            goBack();
        },
    });

    const noteDestination = useMemo<NoteDestination | null>(
        () => (note ? noteDetailsToDestination(note) : null),
        [note],
    );

    return (
        <AnimateLoadedContent isLoading={!note || isLoadingNote || !noteDestination}>
            {() => (
                <View style={{ width: '100%', height: '100%' }}>
                    <NotesEditor
                        key={key}
                        source="resources.edit-note-route"
                        onCancel={goBack}
                        note={note!}
                        noteDestination={noteDestination!}
                        {...noteEditorProps}
                    />
                </View>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(NoteEditScreen);
